import { useAppSelector } from '../../modules/hooks';
import { selectAssetWatchtimeItem } from '../../modules/watchtime';

import type { SvpAssetId } from '@vgtv/api-client/lib/svp_asset';
import type { Vendor } from '../../types';

export const useAssetWatchtimeData = (
  assetId?: SvpAssetId,
  vendor?: Vendor
) => {
  const watchtime = useAppSelector((state) =>
    assetId && vendor
      ? selectAssetWatchtimeItem(state, assetId, vendor)
      : undefined
  );

  const isWatched = watchtime?.isWatched ?? false;

  return {
    watchtime,
    position: isWatched ? undefined : watchtime?.time,
    isWatched,
  };
};
